import { FC } from "react";
import styles from "./Pricing.module.scss";
import { Banner, Button, Fast, NftSniper, Sniper } from "./components";
import NfrFast from "./components/NftFast";
import { getScreenSize } from "@utils/getScreenSize";
import { SwiperSlide, Swiper } from "swiper/react";

const Pricing: FC = () => {
    const { isMobile } = getScreenSize();

    return (
        <section className={styles.pricing}>
            <div className="container">
                <Banner />
            </div>
            {!isMobile ? (
                <div className="container">
                    <div className={styles.items}>
                        <NfrFast>
                            <Button link="https://t.me/nest_dex" />
                        </NfrFast>
                        <NftSniper>
                            <Button link="https://t.me/nest_dex" />
                        </NftSniper>
                        <Fast />
                        <Sniper />
                    </div>
                </div>
            ) : (
                <Swiper slidesPerView={1.01} spaceBetween={8} className={styles.mobileItems}>
                    <SwiperSlide>
                        <NftSniper>
                            <Button link="https://t.me/nest_dex" />
                        </NftSniper>
                    </SwiperSlide>
                    <SwiperSlide>
                        <NfrFast>
                            <Button link="https://t.me/nest_dex" />
                        </NfrFast>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Fast />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Sniper />
                    </SwiperSlide>
                </Swiper>
            )}
        </section>
    );
};

export default Pricing;
